export default "__VITE_ASSET__CmRCx1K1__"